import { render, staticRenderFns } from "./ProposalLayout.vue?vue&type=template&id=a32b1658&scoped=true&"
import script from "./ProposalLayout.vue?vue&type=script&lang=js&"
export * from "./ProposalLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32b1658",
  null
  
)

export default component.exports